<!-- <template>
  <div class="content">
    <div class="login-wrapper">
      <div class="login">
        <h5 class="text-center">Park Ave</h5>
        <h5 class="text-center">Personal Health Record</h5>
        <form @submit.prevent="onSubmit" class="form" ref="formContainer">
          <div class="b-form-group form-group" role="group" id="exampleInputGroup1">
            <label class="col-form-label pt-0">Username: </label>
            <input
              id="exampleInput1"
              type="text"
              v-model="form.patient"
              class="form-control form__input"
              required
              placeholder="Enter username"
            />
          </div>
          <div class="b-form-group form-group" role="group" id="exampleInputGroup2">
            <label class="col-form-label pt-0">Password: </label>
            <input
              id="exampleInput2"
              v-model="form.password"
              class="form-control form__input"
              required
              type="password"
              placeholder="Enter password"
            />
          </div>
          <div class="button-group">
            <button type="submit" class="col-md-12 col-12 btn btn--login">Log in</button>
            <router-link to="/forgot" class="form__link">Forgot password</router-link>
            <router-link to="/register" class="form__link"
              >I don't have an account</router-link
            >
            <div v-bind:class="messageClass" v-html="statusMessage"></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { LoggedIn, LoggingIn } from "@/store/modules/fsm/messages";
import router from "@/router/index";
import { mapActions } from "vuex";
import { post } from "@/store/modules/fsm/index";
import { useLoading } from 'vue-loading-overlay'
export default {
  name: "login-page",
  data() {
    return {
      form: {
        patient: "",
        password: "",
      },
      fullPage: false,
      statusMessage: "",
    };
  },
  props: {
    dest: {
      type: String,
      default: ""
    },
  },
  computed: {
    messageClass: function () {
      return this.statusMessage.length === 0 ? "d-none" : "alert alert-warning";
    },
  },
  methods: {
    ...mapActions("login", ["login"]),
    onSubmit(e) {
      // let form = this.form;

      this.statusMessage = "";
      post({
        message: LoggingIn,
        loader: this.$loading.show(
          {
            container: this.$refs.formContainer,
          },
          {
            after: this.$createElement("div", {}, [`Retrieving application data...`]),
          }
        ),
        ...this.form,
        LoginPage: this,
      });

      // NOTE: the function above should return status of the log in request
      //  so that further actions can be taken based on the status
      //  e.g.: emitting an event that tells server pulse checker to start up
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../stylesheets/mixins/alignment";
$color-base: #0060ff;
.content {
  width: 100%;
  height: auto;
  background: url("../../assets/images/bg.jpg") no-repeat center fixed; // TODO image subject to copyright
  background-size: cover;
  position: relative;
}
.login-wrapper {
  height: 100vh;
  width: 100%;
  position: relative;
}

.login {
  background-color: #fff;
  padding: 2rem;
  -moz-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);

  @include absoluteCenter(380px);
}
.login__introduction {
  color: darken(gray, 10%);
  font-size: 14px;
  text-align: center;
}
.btn--login {
  color: #fff;
  background-color: $color-base;
  &:hover {
    background-color: lighten($color-base, 5%);
  }
}

.button-group {
  margin-top: 1.5rem;

  .form__link {
    color: $color-base;
    font-size: 0.85rem;
    margin-top: 0.5rem;
    display: block;

    &:hover {
      text-decoration: underline;
    }
  }
}

.form__input {
  font-size: 0.85rem;
}
.col-form-label {
  font-size: 14px;
}

@media only screen and (max-width: 468px) {
  .login {
    width: 100%;
  }
}
</style> -->
<template>
  <!-- eh-ds: stylebook primitives (brand-ds.scss). Photo background stays layout. -->
  <div class="content eh-ds">
    <div class="login-wrapper">
      <div class="login">
        <h1 class="text-center login__title">Erriff Health</h1>
        <h2 class="text-center login__subtitle">Personal Health Record</h2>
        <form @submit.prevent="onSubmit" class="form" ref="formContainer">
          <div class="b-form-group form-group">
            <label class="col-form-label pt-0">Username: </label>
            <input
              type="text"
              v-model="form.patient"
              class="form-control form__input"
              required
              placeholder="Enter username"
              autocomplete="username"
              data-allow-autocomplete
            />
          </div>
          <div class="b-form-group form-group">
            <label class="col-form-label pt-0">Password: </label>
            <input
            ref="pwd"
              v-model="form.password"
              class="form-control form__input"
              required
              :type="showPassword ? 'text' : 'password'"
              autocomplete="current-password"
              placeholder="Enter password"
            />
            <button
                  type="button"
                  class="pwd-toggle"
                  @click="togglePassword"
                  @mousedown.prevent
                  :aria-pressed="showPassword"
                  :title="showPassword ? 'Hide password' : 'Show password'"
                  >
                  <!-- simple eye / eye-off SVG (swap based on show) -->
                  <svg v-if="!showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
                    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" stroke="currentColor" stroke-width="1.5"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                  <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
                    <path d="M3 3l18 18" stroke="currentColor" stroke-width="1.5"/>
                    <path d="M1 12s4-7 11-7c2 0 3 .5 4 1.3" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                  </button>
          </div>
          <div class="button-group">
            <button
              type="submit"
              class="col-md-12 col-12 btn btn--login"
              :disabled="isLoading"
            >
              <span v-if="!isLoading">Log in</span>
              <span v-else>Logging in...</span>
            </button>
            <router-link to="/forgot" class="form__link">Forgot password</router-link>
            <router-link to="/org-selection" class="form__link"
              >Start a new organization</router-link
            >
            <div :class="messageClass" v-html="statusMessage"></div>
          </div>
        </form>
      </div>
    </div>
    <!-- The loading overlay from vue-loading-overlay -->
    <!-- Spinner fill is --eh-teal; vue-loading-overlay takes a color string, not a CSS var. -->
    <Loading v-model="isLoading" :is-full-page="true" color="#4b9ca5" />
  </div>
</template>

<script>
import { ref, computed, getCurrentInstance } from "vue";
import { useStore } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
import { LoggingIn } from "@/store/modules/fsm/messages";
const password = ref('')
const show = ref(false)
const pwd = ref(null)

export default {
  name: "LoginPage",
  components: { Loading },
  setup() {
    const store = useStore();
    const instance = getCurrentInstance();
    const form = ref({ patient: "", password: "" });
    const statusMessage = ref("");
    const isLoading = ref(false);

    const messageClass = computed(() =>
      statusMessage.value.length === 0 ? "d-none" : "alert alert-warning"
    );

    const onSubmit = async (e) => {
      e.preventDefault();
      console.log("onSubmit triggered");
      statusMessage.value = "";
      isLoading.value = true;
      try {
        // Dispatch the Vuex login action directly instead of calling post() here.
        await store.dispatch("login/login", {
          patient: form.value.patient,
          password: form.value.password,
          LoginPage: instance?.proxy,
        });
        console.log("Login action dispatched successfully!");
      } catch (error) {
        console.error("Login action failed:", error);
      } finally {
        isLoading.value = false;
      }
    };

    return {
      form,
      statusMessage,
      isLoading,
      messageClass,
      onSubmit,
    };
  },
  data(){
    return{
      showPassword: false,
    }
    
  },
  methods: {
    togglePassword(event) {
    
    this.showPassword = !this.showPassword;
    // keep focus on the main password input
    this.$nextTick(() => {
      const el = this.$refs.pwd;
      if (el && el.focus) el.focus();
     
    });
  }
  }
};
</script>

<style scoped lang="scss">
@import "../../stylesheets/mixins/alignment";
/* Colors/fonts live in the stylebook (.eh-ds in brand-ds.scss). Layout stays here. */

.content {
  width: 100%;
  height: auto;
  background: url("../../assets/images/bg.jpg") no-repeat center fixed;
  background-size: cover;
  position: relative;
}

.login-wrapper {
  height: 100vh;
  width: 100%;
  position: relative;
}

.login {
  padding: 2rem;
  @include absoluteCenter(380px);
}

.login__title {
  font-size: 1.35rem;
  margin: 0 0 0.25rem;
}

.login__subtitle {
  font-size: 1rem;
  margin: 0 0 1.25rem;
}

.b-form-group {
  position: relative;
}

.pwd-toggle {
  background: none;
  border: none;
  position: absolute;
  right: 0.65rem;
  top: 2.05rem;
  padding: 0;
  cursor: pointer;
  line-height: 0;
}

.button-group {
  margin-top: 1.5rem;
  .form__link {
    font-size: 0.85rem;
    margin-top: 0.5rem;
    display: block;
    &:hover {
      text-decoration: underline;
    }
  }
}

.form__input {
  font-size: 0.85rem;
}

.col-form-label {
  font-size: 14px;
}

@media only screen and (max-width: 468px) {
  .login {
    width: 100%;
  }
}
</style>
